import { Box } from '@mui/material'
import axios from 'axios'
import Container from 'components/Container'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { LinksContainer, Path, Section, Title } from './styled'

const SitemapComponent = () => {
  const [routes, setRoutes] = useState<any>(null)
  const [keys, setKeys] = useState<any>(null)
  const [values, setValues] = useState<any>(null)

  const baseURL = process.env.NEXT_PUBLIC_APP_BASE_URL

  const fetchData = async () => {
    try {
      const response = await axios.get(`${baseURL}/routes.json`)
      setRoutes(response.data)
      setKeys(Object.keys(response.data))
      setValues(Object.values(response.data))
    } catch (error) {
      setRoutes(null)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Container>
      <Title>Sitemap</Title>
      {routes && (
        <LinksContainer>
          {keys.map((e: any, index: number) => (
            <Box key={index} component="div">
              <Section>{e === '' ? 'Main' : e}</Section>
              {values[index].map((value: any, index2: number) => (
                <Link key={index2} href={`${baseURL}${e ? `/${e}` : ''}/${value.path}`}>
                  <Path>{value.title === '' ? 'Home' : value.title}</Path>
                </Link>
              ))}
            </Box>
          ))}
        </LinksContainer>
      )}
    </Container>
  )
}

export default SitemapComponent
